__turbopack_context__.v({
  "arrowIcon": "searchresult-module-scss-module__ac-nBq__arrowIcon",
  "articleWrapperStyles": "searchresult-module-scss-module__ac-nBq__articleWrapperStyles",
  "bottomLink": "searchresult-module-scss-module__ac-nBq__bottomLink",
  "cardMainContainer": "searchresult-module-scss-module__ac-nBq__cardMainContainer",
  "cardMainText": "searchresult-module-scss-module__ac-nBq__cardMainText",
  "imageContainer": "searchresult-module-scss-module__ac-nBq__imageContainer",
  "label": "searchresult-module-scss-module__ac-nBq__label",
  "link": "searchresult-module-scss-module__ac-nBq__link",
  "linkText": "searchresult-module-scss-module__ac-nBq__linkText",
  "linkWithIconWrapper": "searchresult-module-scss-module__ac-nBq__linkWithIconWrapper",
  "linkWrapper": "searchresult-module-scss-module__ac-nBq__linkWrapper",
  "mainContainer": "searchresult-module-scss-module__ac-nBq__mainContainer",
  "mainText": "searchresult-module-scss-module__ac-nBq__mainText",
  "paginationNavigationWrapper": "searchresult-module-scss-module__ac-nBq__paginationNavigationWrapper",
  "textContainer": "searchresult-module-scss-module__ac-nBq__textContainer",
  "textLinkStyles": "searchresult-module-scss-module__ac-nBq__textLinkStyles",
  "title": "searchresult-module-scss-module__ac-nBq__title",
  "titleLink": "searchresult-module-scss-module__ac-nBq__titleLink",
});
